<template>
	<div class="testPage">
		<video src="../assets/video/bg_home_g.mp4" autoPlay muted="true" loop="true" class="video"></video>
		<div class="t-content" :style="{ 'margin-left': marginLeft + 'px' }">
			<endTime :endtime="user.endDate"></endTime>
			<p class="top-title">{{ nowInfo.name }}</p>
			<p class="top-second-title"><span>*</span> {{ nowInfo.message }}</p>
			<AutoForm :qusList="list" :name="name" @changeLoading="changeLoading" @changeNowInfo="changeNowInfo"/>
		</div>
		<div class="fixed-message" v-show="type === 1">
			<div class="word-box">
				<p>{{ qusIndex }}/{{ qusLength }}<br>
					{{ dimensionName }}</p>
			</div>
		</div>
		<span v-loading.fullscreen.lock="loading"></span>
	</div>
</template>

<script>
// @ is an alias to /src
import Cookies from 'js-cookie';
import {
	questionApi
} from '../api/api-url/question.js'
// import {
// 	testPageApi
// } from '../api/api-url/testPage.js'
import endTime from '../components/time.vue'
import AutoForm from '../components/autoForm.vue'
import store from '../store/index';
export default {
	name: 'TestPage',
	components: {
		endTime,
		AutoForm
	},
	data() {
		return {
			info: {},
			user: {},
			infoId: '',
			name: '',
			type: '',
			marginLeft: 0,
			page: 1,
			size: 10,
			nowInfo: {},
			state1: '',
			restaurants: [],
			loading: false,
			list: [],
			qusIndex: 0,
			qusLength: 0,
			dimensionName: ''
		}
	},
	created() {
		this.marginLeft = (window.screen.width - 1200) / 2;
		// this.infoId = this.$route.query.infoId;
		// this.name = this.$route.query.name;
		// this.type = this.$route.query.type;
		this.qusIndex = this.$route.query.qusIndex;
		this.qusLength = this.$route.query.qusLength;
		this.dimensionName = this.$route.query.dimensionName;
		this.getUserInfo();
		// this.getQuestionnaireInfo()
	},
	methods: {
		changeLoading(val){
			this.loading = val
		},
		changeNowInfo(val){
			this.nowInfo = val
		},
		// 获取用户和问卷信息
		async getUserInfo() {
			let res = await questionApi.selectUserInfo()
			if (res) {
				Cookies.set('companyName', res.result.user.companyName, {
					expires: 30
				})
				this.info = res.result.info;
				this.user = res.result.user;
			}
		},
		// 获取题目
		// async getQuestionnaireInfo(infoId, name, type, page, size) {
		// 	this.loading = true
		// 	let res = await testPageApi.selectQuestionnaireInfo({
		// 		infoId,
		// 		name,
		// 		type,
		// 		page,
		// 		size,
		// 	})
		// 	if (res) {
		// 		this.nowInfo = res.result.info;
		// 		let list = res.result.data
		// 		// console.log(res.result.data);
		// 		for (let i = 0; i < list.length; i++) {
		// 			let valueList = list[i].calculationValue.split(',')
		// 			if (list[i].parentId !== null) {
		// 				if (list[i].answer == null) {
		// 					list[i].answer = '无'
		// 				}
		// 			}
		// 			if (list[i].calculationMethod === '12') {
		// 				list[i].answer = '否'
		// 				if (localStorage.parentAnswerList) {
		// 					let parentList = JSON.parse(localStorage.parentAnswerList)
		// 					for (const j in parentList) {
		// 						if (parentList[j].id == list[i].id)
		// 							list[i].answer = parentList[j].value
		// 					}
		// 				}
		// 				store.commit('setQuestionstate', {
		// 					id: list[i].id,
		// 					value: list[i].answer
		// 				})
		// 			}

		// 			if (list[i].dataSourceValue != null) {
		// 				let dataSourceValueList = list[i].dataSourceValue.split(',')
		// 				list[i].dataSourceValue = []

		// 				for (let k = 0; k < dataSourceValueList.length; k++) {
		// 					list[i].dataSourceValue.push({
		// 						value: dataSourceValueList[k]
		// 					})
		// 				}
		// 			}

		// 			list[i].calculationValue = []
		// 			for (let j = 0; j < valueList.length; j++) {
		// 				list[i].calculationValue.push({
		// 					value: valueList[j]
		// 				})
		// 			}
		// 		}
		// 		// if (localStorage.pageMessageObj) {
		// 		// 	let obj = JSON.parse(localStorage.pageMessageObj)
		// 		// 	if (obj[this.name]) {
		// 		// 		list = obj[this.name]
		// 		// 	}
		// 		// }
		// 		this.list = list
		// 		// console.log(this.list);

		// 		this.loading = false
		// 	}
		// },

	},
	mounted() {
		store.commit('setRadio', this.type)
	}
}
</script>

<style lang="scss" scoped>
.testPage {
	overflow-x: hidden;
	background-color: #F3F5F6;
	height: 100%;

	.video {
		position: relative;
		top: -260px
	}

	.t-content {
		width: 1200px;
		background-color: #fff;
		padding-top: 20px;
		margin-bottom: -226px;
		position: relative;
		top: -260px;

		.top-title {
			text-align: center;
			font-size: 24px;
			color: #333333;
			font-weight: 700;
			margin-top: 30px;
			margin-bottom: 20px;
		}

		.top-second-title {
			font-size: 16px;
			text-align: center;
			margin-bottom: 40px;

			span {
				color: red;
			}
		}
	}

	.fixed-message {
		position: fixed;
		right: 120px;
		bottom: 120px;
		background-color: #fff;
		text-align: center;
		border-radius: 50%;
		font-size: 16px;
		font-weight: 400;
		color: #333333;

		.word-box {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 68px;
			height: 68px;
		}

		p {
			line-height: 20px;
		}
	}
}
</style>